import React, {Component} from "react";
import "./ViewComplaint.css";
import {FormattedMessage} from "react-intl";
import ShowMoreText from "react-show-more-text";

class ViewReplies extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        // {console.log("dddds2 ->", this.props.inquiry.userId)}
        // {console.log("dddds3 ->", this.props.replyData.replySentByUser)}
        return (
            <div className="color-text">
                {/*{console.log("dddddddss", this.props)}*/}
                {this.props.replyData.isFromAdminPanel !== true?
                    <div className="row complaint-right-margin-replies-admin">
                        <div className="inquiry-reply-row-margin">
                            <div className="col-md-6 no-padding-left text-left">
                                <text className="inquiry-reply-flow-txt">お客様&nbsp;
                                    {this.props.replyData.replySentOn.substring(0,4)} 年 {this.props.replyData.replySentOn.substring(5,7)} 月
                                    {this.props.replyData.replySentOn.substring(8,10)} 日&nbsp;&nbsp;{this.props.replyData.replySentOn.substring(11,16)}
                                </text>
                                <div id="view-admin-reply-txt-area" className="text-left ">
                                    <ShowMoreText
                                        lines={3}
                                        more='続きを読む'
                                        less='閉じる'
                                        anchorClass=''
                                    >
                                        {this.props.replyData.replyMessage}
                                    </ShowMoreText>

                                </div>

                            </div>
                        </div>
                    </div>:
                    <div className="row">
                        <div className="col-md-5"></div>
                        <div className=" col-md-6 inquiry-reply-row-margin">
                            <div className="inquiry-reply-flow-txt flow-txt">管理者&nbsp;
                            {this.props.replyData.replySentOn.substring(0,4)} 年 {this.props.replyData.replySentOn.substring(5,7)} 月
                            {this.props.replyData.replySentOn.substring(8,10)} 日&nbsp;&nbsp;{this.props.replyData.replySentOn.substring(11,16)}
                        </div>
                            <div className=" no-padding-left text-right">
                                <div id="view-my-reply-txt-area" className="text-left admin-complaint-content complaint-right-margin-replies">
                                    <ShowMoreText
                                        lines={3}
                                        more='...詳細'
                                        less='...閉じる'
                                        anchorClass=''
                                    >
                                        {this.props.replyData.replyMessage}
                                    </ShowMoreText>
                                </div>
                            </div>
                        </div>
                    </div>

                }
            </div>
        )
    }

}

export default ViewReplies;



// WEBPACK FOOTER //
// ./src/components/Admin/NewQualityComplaint/ViewComplaint/ViewReplies.js